module.exports = __webpack_public_path__ + "static/media/simone-malfra.a59a56e3.jpeg";